// Use require to avoid circular dependency issue...
require("../analytics");

// models
export { default as User } from "./models/User";
export type { UserType, OptionalUserType } from "./models/User";
export { default as UserPreferences } from "./models/UserPreferences";
export type {
  UserPreferencesType,
  OptionalUserPreferences
} from "./models/UserPreferences";
export { default as UserStateSlice } from "./models/UserStateSlice";
export type {
  UserStateSliceType,
  OptionalUserStateSliceType
} from "./models/UserStateSlice";
export { default as SignInState } from "./models/SignInState";
export type { OptionalSignInStateType } from "./models/SignInState";
export { default as PasswordResetState } from "./models/PasswordResetState";
export type {
  PasswordResetStateType,
  OptionalPasswordResetStateType
} from "./models/PasswordResetState";

// selectors
export {
  getUserSlice,
  getUserDetails,
  getUserId,
  getUserDisplayName,
  getUserEmail,
  getUserGivenName,
  getUserFamilyName,
  getUserYearGroup,
  getUserPhoneNumber,
  getUserAccountType,
  getTeacherRole,
  getUserNickName,
  getUserSignInState,
  isSignedIn,
  isSigningIn,
  isSigningOut,
  isSignedInAsGuest,
  userHasSignedInBefore,
  isFirstUserSession,
  credentialsRefreshHasErrored,
  getPasswordResetSlice,
  getPasswordResetEmail,
  getUserMetaSlice,
  getPasswordResetMetaState,
  getResubmitCodeError,
  getResubmitCodePending,
  getResubmitCodeSuccess,
  getUserManagedBy,
  isUserManaged,
  getUserExternalSchoolId,
  getUserChosenSchool
} from "./selectors";
export {
  getUserPreferences,
  getUserHasPickedDisplayName,
  getMapGradient,
  getTypingPreference,
  getAgeGroup,
  getRegion,
  getAgeGroupPreferenceOption,
  getNotifyWhenDataRequestReady,
  smartLearningIsEnabled,
  areSoundEffectsEnabled,
  getPreferredThemeMode,
  getPreferredStats
} from "./selectors/preferences";
export {
  getUpdatePreferencesStarted,
  getUpdatePreferencesError
} from "./selectors/preferencesMeta";
export {
  getUpdateInfoStarted,
  getUpdateInfoSuccess,
  getUpdateInfoErrorMessage,
  getUserInfoFetchFinished
} from "./selectors/userInfoMeta";

// reducers
export { default as reducer } from "./reducers";
export { PATH_TO_USER_STATE } from "./consts";

// actions
export {
  setUser,
  updateUserPersonalInformation,
  userInfoFetchActionFactory,
  userInfoCreateActionFactory,
  userInfoUpdateActionFactory
} from "./actions";
export {
  setUserPreferences,
  updateUserPreferences,
  userPreferencesFetchActionFactory,
  userPreferencesUpdateActionFactory
} from "./actions/preferences";
export {
  updatePasswordResetEmail,
  updatePasswordActionFactory
} from "./actions/passwordReset";
export {
  signInStart,
  signOutStart,
  signInSuccess,
  signUpSuccess,
  signInSuccessAsGuest,
  signInError,
  signOut,
  signOutError,
  setUserHasSignedUpBefore,
  logCredentialsRefresh,
  refreshCredentialsError
} from "./actions/signInState";

// action-types
export { default as signInActionTypes } from "./action-types/signInState";
